module.exports = __webpack_public_path__ + "static/media/refreshSound.5cc5bcb2.wav";